import {useState} from 'react';

import InfoIcon from 'assets/icons/infoIcon';
import {useAppSelector} from 'hooks';
import {PriceBreakdown} from 'types';
import {DeliveryFeeModal} from 'views/basket-modals/DeliveryFeeModal';

const DeliveryFeeIcon = () => {
  const [open, setOpen] = useState(false);
  const basket = useAppSelector((state) => state?.basket?.basket);

  let showFreeDeliveryText = true;

  if (!basket?.prices || !basket?.prices?.priceBreakdown?.length) {
    return null;
  }
  const priceBreakdown: PriceBreakdown[] | undefined = basket.prices.priceBreakdown;
  if (basket.prices.shippingFee > 0) {
    showFreeDeliveryText = false;
  }

  if (!priceBreakdown || !priceBreakdown?.length) {
    return null;
  }

  return (
    <>
      <InfoIcon cursor="pointer" onClick={() => setOpen(true)} fontSize={'small'} />
      {open && (
        <DeliveryFeeModal
          open={open}
          onClose={() => setOpen(false)}
          priceBreakdown={priceBreakdown}
          showFreeDeliveryText={showFreeDeliveryText}
        />
      )}
    </>
  );
};

DeliveryFeeIcon.displayName = 'DeliveryFeeIcon';

export default DeliveryFeeIcon;
